/**
 * Home
 * 
 */

var productos = new (function(){

    var that = this;
    
    this.init = function(){
        var slider = $('.productos .sliderprod');

        slider.owlCarousel({
            items:1,
            loop:false,
            dots:false,
            nav:true,
            margin:26,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1
                },
                480:{
                    items:2    
                },
                768:{
                    items:3
                },
            }

        }); 
   
   
    };

})();